/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Pb_MarathonInputs */

const en_ui_pb_marathon = /** @type {(inputs: Ui_Pb_MarathonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marathon`)
};

const de_ui_pb_marathon = /** @type {(inputs: Ui_Pb_MarathonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marathon`)
};

/**
* | output |
* | --- |
* | "Marathon" |
*
* @param {Ui_Pb_MarathonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_pb_marathon = /** @type {((inputs?: Ui_Pb_MarathonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Pb_MarathonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_pb_marathon(inputs)
	return de_ui_pb_marathon(inputs)
});